// Invitation Evaluation list: GET /procurement/getall-list-invitation-evaluation
// query builder and the Excel/CSV export. Fetch and download helpers are shared
// with the Plan & Procurement list.

import { api } from '../../../config';
import { formatDateToDDMMYYYY } from '../../../utils/dateformatter';
import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const INVEVAL_PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// Column id -> SortBy value. Ids without an entry are sent as-is.
export const INVEVAL_SORT_FIELDS = {
  procurementnumber: 'procurementnumber',
  titleprocurement: 'titleprocurement',
  procurementtype: 'procurementtype',
  description: 'description',
  isProcurementCompleted: 'isProcurementCompleted',
};

export const DEFAULT_SORT_FIELD = 'isInvitePanitiaTenderCompletedDate';

export const isConfirmed = row =>
  row?.invitationEvaluationStatus === 'Confirmed';

// Status metadata for the invitation evaluation stat cards and dropdown. The
// id is the tab key used by `matchesInvEvalStatus` ('' = no status filter).
export const INVEVAL_STATUS_TABS = [
  {
    id: 'unconfirmed',
    label: 'Unconfirmed',
    icon: 'ri-close-circle-line',
  },
  {
    id: 'confirmed',
    label: 'Confirmed',
    icon: 'ri-checkbox-circle-line',
  },
];

export const DEFAULT_STATUS_TAB = 'unconfirmed';

// The list endpoint ignores status query params, so filtering happens on the
// client against the row's invitationEvaluationStatus ('' = no status filter).
export const matchesInvEvalStatus = (row, tabId) => {
  if (tabId === 'confirmed') return isConfirmed(row);
  if (tabId === 'unconfirmed') return !isConfirmed(row);
  return true;
};

export const buildInvitationEvalListUrl = ({
  currentPage,
  rowsPerPage,
  procurementTypeHeader,
  search,
  sortField,
  sortDirection,
}) => {
  const params = new URLSearchParams();
  params.set('PageNumber', String(currentPage));
  params.set('PageSize', String(rowsPerPage));
  if (procurementTypeHeader) {
    params.set('ProcurementTypeHeader', procurementTypeHeader);
  }
  if (search?.trim()) params.set('Search', search.trim());
  if (sortField) {
    params.set('SortBy', sortField);
    params.set('IsDescending', sortDirection === 'desc' ? 'true' : 'false');
  }
  return `${api.API_URL}/procurement/getall-list-invitation-evaluation?${params.toString()}`;
};

const toExportRow = row => ({
  'ID Proc': row.procurementNumber || '',
  'Submitted Date':
    formatDateToDDMMYYYY(row.isInvitePanitiaTenderCompletedDate) || '',
  Title: row.titleProcurement || '',
  'Proc Type': INVEVAL_PROCUREMENT_TYPE_MAP[row.procurementType] || '',
  Product: row.productType?.name || '',
  'Product Type':
    getListProductTypeLabel(row, row.productType?.description) || '',
  Description: row.description || '',
  Status: row.invitationEvaluationStatus || '',
});

export const exportInvitationEvalList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(toExportRow), {
    format,
    prefix: 'InvitationEvaluation',
    sheetName,
  });
